<!-- NumColorCell.vue -->
<template>
  <div :class="formatClass">{{ formatText }}{{ absNum }}</div>
</template>

<script>
export default {
  name: "NumColorCell",
  props: {
    num: {
      type: [String, Number, undefined], // 接受 String、Number 和 undefined 类型
      required: true,
    },
  },
  computed: {
    parsedNum() {
      if (
        typeof this.num === "undefined" ||
        (typeof this.num === "string" && this.num.trim() === "")
      ) {
        return "";
      }
      return Number(this.num);
    },
    absNum() {
      return Math.abs(this.parsedNum);
    },
    formatText() {
      if (this.parsedNum === "") {
        return "";
      }
      if (this.parsedNum > 0) {
        return "多";
      }
      if (this.parsedNum < 0) {
        return "少";
      }
      return "";
    },
    formatClass() {
      if (this.parsedNum === "") {
        return "blackClass";
      }
      if (this.parsedNum > 0) {
        return "redClass";
      }
      if (this.parsedNum < 0) {
        return "greenClass";
      }
      return "blackClass";
    },
  },
};
</script>

<style scoped>
.redClass {
  color: red;
}

.greenClass {
  color: green;
}

.blackClass {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/pages/receiveGoods/StockVarianceProcess/components/NumColorCell.vue